import { defaultParams, STORAGE_KEY, FOLDERS_KEY } from './defaults.js'
import { debugPresets } from './debugPresets.js'

const isDebug = new URLSearchParams(window.location.search).get('debug') === 'true'
export const isCarbonPage = document.body?.dataset.page === 'carbon'
const falmecPreset = debugPresets[isCarbonPage ? 'Carbon' : 'Vik 5']

// Chiave separata per pagina: i tweak debug della home non contaminano carbon e viceversa
export const storageKey = isCarbonPage ? STORAGE_KEY + '-carbon' : STORAGE_KEY

const deepClone = (obj) => JSON.parse(JSON.stringify(obj))

export const params = deepClone({ ...defaultParams, ...falmecPreset })

// In debug, restore tweaks from localStorage on top of the page baseline.
// In production, always boot fresh from the preset — no persistence.
if (isDebug) {
    try {
        const saved = JSON.parse(localStorage.getItem(storageKey))
        if (saved) Object.assign(params, saved)
    } catch(e) {}
}

export const saveParams = () => {
    if (!isDebug) return
    localStorage.setItem(storageKey, JSON.stringify(params))
}

export const loadFolderState = () => {
    try {
        return JSON.parse(localStorage.getItem(FOLDERS_KEY)) || {}
    } catch(e) {
        return {}
    }
}

export const saveFolderState = (state) => {
    localStorage.setItem(FOLDERS_KEY, JSON.stringify(state))
}
